import { z } from 'zod';

export const productOwnershipSchema = z.object({
  accountState: z.string(),
  expirationDate: z.string().nullable(),
});

export type ProductOwnership = z.infer<typeof productOwnershipSchema>;
